import React from "react";

import "./Footer.css"; // Create a CSS file for styling
import {
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaWhatsapp,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import useWorkSection from "../../data-access/useWorkSection";

const Footer = () => {
  const { workSection } = useWorkSection({ page: "work_section" });
  return (
    <footer>
      <div className="footer-container">
        <div className="upper-footer">
          <div className="footer-section">
            <h2>About Company</h2>
            <p>
              Established in 2013, the Excellent Civil Academy Trust (ECAT) is a
              women-led national non-profit organization dedicated to promoting
              women’s empowerment, education, and social transformation across
              India. Registered under the Indian Trust Act, 1882, ECAT works to
              achieve inclusive growth, gender equality, and sustainable
              community development through education, vocational training, and
              awareness initiatives.
            </p>
          </div>

          <div className="footer-section">
            <h2>Services</h2>
            <ul>
              {workSection?.map((ws) => (
                <li key={ws?._id}>
                  <Link to={`/ourwork?sectionId=${ws?._id}`}>{ws?.name}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-section">
            <h2>Contact</h2>
            <p>Email: ecat.bharat@gmail.com</p>
            <p>Phone: 9355602224</p>
          </div>
        </div>
        <div className="lower-footer">
          <div className="social-links">
            <a
              className="social-link facebook"
              href="https://www.facebook.com/ECAT.bharat/about/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <FaFacebookF />
            </a>
            <a
              className="social-link instagram"
              href="https://www.instagram.com/ecat_group_support?igsh=MTd6cTVkYTFhaGR1MA%3D%3D&utm_source=qr"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <FaInstagram />
            </a>
            <a
              className="social-link youtube"
              href="https://www.youtube.com/@excellentlearningvolunteer9962"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
            >
              <FaYoutube />
            </a>
            <a
              className="social-link whatsapp"
              href=""
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
            >
              <FaWhatsapp />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
